module.exports = __webpack_public_path__ + "components/flag/static/square/jm-423d74f64499c8fc3e609f5a5edb0166.svg";